import { Firm } from 'api/interfaces/firm';
import { CRUDButtons } from 'components/CRUDButtons';
import { Alignment, ColumnDefinition, ColumnType } from 'components/Table/types/column';

interface FirmsColumnsConfig {
  readonly canEdit: boolean;
  readonly canDelete: boolean;
}

export const createFirmsColumns = ({
  canEdit,
  canDelete,
}: FirmsColumnsConfig): ReadonlyArray<ColumnDefinition<Firm>> => [
  {
    minWidth: 48,
    columnType: ColumnType.custom,
    key: 'firmID',
    filterable: false,
    header: '',
    component: (props) => (
      <CRUDButtons {...props} disableEdit={!canEdit} disableDelete={!canDelete} showDelete={true} />
    ),
  },
  {
    columnType: ColumnType.text,
    key: 'firmName',
    filterable: true,
    header: 'MPID',
    weight: 4,
    alignment: Alignment.center,
  },
  {
    columnType: ColumnType.text,
    key: 'firmLabel',
    filterable: true,
    header: 'Name',
    weight: 15,
  },
  {
    columnType: ColumnType.text,
    key: 'firmType',
    filterable: true,
    header: 'Type',
    weight: 4,
    alignment: Alignment.center,
  },
  {
    columnType: ColumnType.text,
    key: 'businessAddress',
    filterable: true,
    header: 'Business Address',
    weight: 4,
    alignment: Alignment.center,
  },
];
